export default {
	"bulk.premiumCalc.expand": "Details erweitern",
	"bulk.premiumCalc.continue": "Weiter",
	"bulk.premiumCalc.title": "Wählen Sie einen passenden Versicherungsschutz",
	"bulk.premiumCalc.description":
		"Wenn Sie Ihre WEGs versichern möchten, dann können Sie dies einfach mit unserer Upload-Funktion tun. Wählen Sie hierzu einen Versicherungsschutz aus und befüllen Sie im nächsten Schritt die Excel zur Prämien-Berechnung.",
	"bulk.premiumCalc.price": "Prämie Brutto:",
} as const;
